/**
 * useEvidenceArtefactDetail (P75.2).
 *
 * Wraps GET /v1/evidence/{id} via React Query. Returns the richer
 * EvidenceArtefactDetail shape (metadata + freshness + linked
 * assessments + linked findings). Symmetric with useFindingDetail
 * (P70).
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { api, type ApiError } from "shared/api/client";
import type { EvidenceArtefactDetail } from "shared/api/types";

export const evidenceDetailKeys = {
  all: ["evidence-detail"] as const,
  byId: (id: string) => [...evidenceDetailKeys.all, id] as const,
};

export function useEvidenceArtefactDetail(
  artefactId: string | undefined,
): UseQueryResult<EvidenceArtefactDetail, ApiError> {
  return useQuery({
    queryKey: evidenceDetailKeys.byId(artefactId ?? ""),
    queryFn: () => api.get<EvidenceArtefactDetail>(`/v1/evidence/${artefactId}`),
    enabled: Boolean(artefactId),
    staleTime: 30_000,
  });
}
